<template>
  <div>
    <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4"> {{this.$attrs.action == "Create" ? "Setup New" : this.$attrs.action == "Edit" ? "Edit" : ""}} Address</h6>
    <hr class="mb-0">
    <a-spin :spinning="spinning">
        <div class="card mt-3 border-0">
            <base-input label="Region" required>
                <a-select v-model="address.region_code" size="large" showSearch placeholder="Select Region" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('provinces')" :disabled="addressLoading == true">
                    <a-select-option v-for="option in addressOptions.regions" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                </a-select>
            </base-input>
            <base-input label="Province" required>
                <a-select v-model="address.province_code" size="large" showSearch placeholder="Select Province" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('cities')" :disabled="addressLoading == true">
                    <a-select-option v-for="option in addressOptions.provinces" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                </a-select>
            </base-input>

            <base-input label="City" required>
                <a-select v-model="address.city_code" size="large" showSearch placeholder="Select City" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('barangays')" :disabled="addressLoading == true">
                    <a-select-option v-for="option in addressOptions.cities" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                </a-select>
            </base-input>

            <base-input label="Barangay" required>
                <a-select v-model="address.barangay_code" size="large" showSearch placeholder="Select Barangay" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="changeAddress('none')" :disabled="addressLoading == true">
                    <a-select-option v-for="option in addressOptions.barangays" :key="option.code" :value="option.code">{{option.name}}</a-select-option>
                </a-select>
            </base-input>
            <base-input label="House No. / Street" required>
                <a-input type="text"  size="large" v-model="address.street"/>
            </base-input>
        </div>
    </a-spin>
    <div v-if="this.$attrs.viewMode != true">
        <div v-if="serverType == 'ho' && spinning == false" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
            <button v-if="(profileId == 0 && this.$attrs.action == 'Create')" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
            <button v-else-if="(this.$attrs.action == 'Edit')" type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
        </div>
        <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
            <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
        </div>
    </div>
  </div>
</template>
<script>
    import axios from "axios";
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {
            var autoLogin = secureStorage.getItem("ecomLoggedIn")
            if(autoLogin == true){
                this.salesChannelId = secureStorage.getItem("SalesChannelDetails").id
                this.storeDetails = secureStorage.getItem("SalesChannelDetails")
                component_x = this
                this.CustomerAccountDetails = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin")
                await this.changeAddress('regions', 1);
                if (this.$attrs.AddressId > 0){
                    this.spinning = true;
                    var response = await HTTPRequest.getRequest(component_x.endPoint + 'customer_addresses/' + this.$attrs.AddressId+'?email='+this.CustomerAccountDetails.email+'&account_id='+this.storeDetails.account_id, null)
                    var address_data = response
                    console.log(response)
                    if(address_data == undefined){
                        component_x.$router.go()
                    } else {
                        if(address_data["error"] == undefined){
                            component_x.id = address_data["id"]
                            component_x.address.region_code = address_data["region_code"]
                            component_x.address.region_name = address_data["region_name"]
                            component_x.address.province_code = address_data["province_code"]
                            component_x.address.province_name = address_data["province_name"]
                            component_x.address.city_code = address_data["city_code"]
                            component_x.address.city_name = address_data["city_name"]
                            component_x.address.barangay_code = address_data["barangay_code"]
                            component_x.address.barangay_name = address_data["barangay_name"]
                            component_x.address.street = address_data["street"]
                            await this.changeAddress('provinces', 1);
                            await this.changeAddress('cities', 1);
                            await this.changeAddress('barangays', 1);
                            this.spinning = false;
                        } else {
                            this.errors = address_data["error"].split(",");
                        } 
                    }
                }
            }else{
                this.$router.push({ name: 'loading_screen', params: { returnUrl: 'customer_login' }})
            }
        },
        data() {
            return {
                spinning:false,
                id:"",
                address:{
                    region_code: null,
                    region_name: "",
                    province_code: null,
                    province_name: "",
                    city_code: null,
                    city_name: "",
                    barangay_code: null,
                    barangay_name: "",
                    street:null,
                },
                addressLoading:false,
                    addressOptions: {
                    regions: [],
                    provinces: [],
                    cities: [],
                    barangays: []
                },
                CustomerAccountDetails:{}
            };
        },
        methods: {
            AddressValidation(){
                this.errors = [];
                this.errors.push(ValidateField.required('Region', this.address.region_code));
                this.errors.push(ValidateField.charMinAndMax('Region', this.address.region_name, 0, 200));
                this.errors.push(ValidateField.required('Province', this.address.province_code));
                this.errors.push(ValidateField.charMinAndMax('Province', this.address.province_name, 0, 100));
                this.errors.push(ValidateField.required('City', this.address.city_code));
                this.errors.push(ValidateField.charMinAndMax('City', this.address.city_name, 0, 60));
                this.errors.push(ValidateField.required('Barangay', this.address.barangay_code));
                this.errors.push(ValidateField.charMinAndMax('Barangay', this.address.barangay_name, 0, 60));
                this.errors.push(ValidateField.required('House No. / Street', this.address.street));
                this.errors.push(ValidateField.charMinAndMax('House No. / Street', this.address.street, 0, 100));
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            create: async function () {
                if(!this.AddressValidation()) {
                    var AddressPayload = {
                        address: {
                            region_code: this.address.region_code, 
                            region_name: this.address.region_name,
                            province_code: this.address.province_code,
                            province_name:this.address.province_name,
                            city_code:this.address.city_code,
                            city_name:this.address.city_name,
                            barangay_code:this.address.barangay_code,
                            barangay_name:this.address.barangay_name,
                            street:this.address.street
                        }
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'customer_addresses?email='+this.CustomerAccountDetails.email+'&account_id='+this.storeDetails.account_id, null, AddressPayload)    
                    console.log(post_request)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                var AddressPayload = {
                    address: {
                        region_code: this.address.region_code, 
                        region_name: this.address.region_name,
                        province_code: this.address.province_code,
                        province_name:this.address.province_name,
                        city_code:this.address.city_code,
                        city_name:this.address.city_name,
                        barangay_code:this.address.barangay_code,
                        barangay_name:this.address.barangay_name,
                        street:this.address.street
                    }
                }
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'customer_addresses/' + this.id+'?email='+this.CustomerAccountDetails.email+'&account_id='+this.storeDetails.account_id, null, AddressPayload)
                if (put_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (put_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",")
                    }
                }
            },
            changeAddress: async function(list, fresh = 0){
                this.addressLoading = true
                switch(list) {
                case 'regions':
                    await this.getAddressList(null, null, list)
                    this.sort(this.response)
                    this.addressOptions = {
                        regions: this.response,
                        provinces: [],
                        cities: [],
                        barangays: []
                    }
                    if(fresh == 0){
                        Object.assign(this.address, {
                            province_code: null,
                            province_name: "",
                            city_code: null,
                            city_name: "",
                            barangay_code: null,
                            barangay_name: ""
                        });    
                    }
                    break;
                case 'provinces':
                    let province_list = []
                    let district_list = []
                    if(this.address.region_code != null){
                        await this.getAddressList(list, this.address.region_code, 'regions')
                        province_list = this.response
                        
                        await this.getAddressList('districts', this.address.region_code, 'regions')
                        district_list = this.response

                        Object.assign(this.address, {
                            region_name: this.addressOptions.regions.find(x => x.code === this.address.region_code).name
                        })
                    }
                    let provinces_arr = province_list.concat(district_list)
                    this.sort(provinces_arr)
                    Object.assign(this.addressOptions, {
                        provinces: provinces_arr,
                        cities: [],
                        barangays: []
                    });
                    if(fresh == 0){
                        Object.assign(this.address, {
                            province_code: null,
                            province_name: "",
                            city_code: null,
                            city_name: "",
                            barangay_code: null,
                            barangay_name: ""
                        });
                    }
                    break;
                case 'cities':
                    let province_city_list = []
                    let province_municipality_list = []
                    let province_sub_municipality_list = []
                    let district_city_list = []
                    let district_municipality_list = []
                    let district_sub_municipality_list = []
                    if(this.address.province_code != null){
                        await this.getAddressList(list, this.address.province_code, 'provinces')
                        province_city_list = this.response

                        await this.getAddressList('municipalities', this.address.province_code, 'provinces')
                        province_municipality_list = this.response

                        await this.getAddressList('sub-municipalities', this.address.province_code, 'provinces')
                        province_sub_municipality_list = this.response

                        await this.getAddressList(list, this.address.province_code, 'districts')
                        district_city_list = this.response

                        await this.getAddressList('municipalities', this.address.province_code, 'districts')
                        district_municipality_list = this.response

                        await this.getAddressList('sub-municipalities', this.address.province_code, 'districts')
                        district_sub_municipality_list = this.response

                        Object.assign(this.address, {
                            province_name: this.addressOptions.provinces.find(x => x.code === this.address.province_code).name
                        })
                    }
                    let cities_arr = province_city_list.concat(province_municipality_list, province_sub_municipality_list, district_city_list, district_municipality_list, district_sub_municipality_list)
                    this.sort(cities_arr)
                    Object.assign(this.addressOptions, {
                        cities: cities_arr,
                        barangays: []
                    });
                    if(fresh == 0){
                        Object.assign(this.address, {
                            city_code: null,
                            city_name: "",
                            barangay_code: null,
                            barangay_name: ""
                        });
                    }
                    break;
                case 'barangays':
                    let city_barangay_list = []
                    let municipality_barangay_list = []
                    let sub_municipality_barangay_list = []
                    if(this.address.city_code != null){
                        await this.getAddressList(list, this.address.city_code, 'cities')
                        city_barangay_list = this.response
                        await this.getAddressList(list, this.address.city_code, 'municipalities')
                        municipality_barangay_list = this.response
                        await this.getAddressList(list, this.address.city_code, 'sub-municipalities')
                        sub_municipality_barangay_list = this.response

                        Object.assign(this.address, {
                            city_name: this.addressOptions.cities.find(x => x.code === this.address.city_code).name
                        })
                        this.addressOptions.barangays = this.response
                    }
                    let barangay_arr = city_barangay_list.concat(municipality_barangay_list, sub_municipality_barangay_list)
                    this.sort(barangay_arr)
                    Object.assign(this.addressOptions, {
                        barangays: barangay_arr
                    });
                    if(fresh == 0){
                        Object.assign(this.address, {
                            barangay_code: null,
                            barangay_name: ""
                        });
                    }
                    break;
                default:
                    if(this.address.barangay_code != null){
                        Object.assign(this.address, {
                            barangay_name: this.addressOptions.barangays.find(x => x.code === this.address.barangay_code).name
                        })
                    }
                }
                this.addressLoading = false
            },
            getAddressList: async function(list, parent_code, parentList){
                let code
                if (parent_code == null){
                    code = ''
                } else {
                    code = parent_code + '/' + list
                }
                await axios({
                    method: 'GET',
                    url: 'https://psgc.gitlab.io/api/' + parentList + '/' + code
                })
                .then(function (response) {
                    let response_data = response.data
                    let response_array = []
                    for (let index = 0; index < response_data.length; index++) {
                        let row_set = response_data[index]
                        response_array.push({
                            code: row_set.code.toString(),
                            name: row_set.name
                        })
                    }
                    component_x.response = response_array
                }).catch(err => {
                    component_x.response = []
                })
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
        },
    };
</script>
<style>
    .ant-list-header, .ant-list-footer {
        padding-top: 6px;
        padding-bottom: 6px;
    }
    .custom-scrollbar-css::-webkit-scrollbar {
        width: 5px!important;
    }
    .custom-scrollbar-css::-webkit-scrollbar-track {
    background: #eee!important;
    }
    .custom-scrollbar-css::-webkit-scrollbar-thumb {
    border-radius: 1rem!important;
    background-color: #00d2ff!important;
    background-image: linear-gradient(to top, #00d2ff 0%, #3a7bd5 100%)!important;
    }
    .custom-scrollbar-css {
        overflow-y: scroll;
    }

</style>
<style lang='scss'>
    @import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
</style>